<input nbInput [nbDatepicker]="datepicker" [(ngModel)]="fecha">
<nb-datepicker #datepicker format="dd/MM/yyyy" (dateChange)="onChange($event)"></nb-datepicker>
